import { Abstrap } from '..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'ul' };

class Breadcrumb extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-breadcrumb',
            className,
        ];
    }

}

Breadcrumb.propTypes = propTypes;

Breadcrumb.defaultProps = defaultProps;

export default Breadcrumb;
